import React from "react";
import Modal from "../../../../components/modal";

interface Props {
  titulo: string;
  texto: string;
  confirmarLabel: string;
  ocupado?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/** Confirmação própria (sem window.confirm): o foco inicial fica em "Cancelar", a ação segura. */
const ConfirmarModal: React.FC<Props> = ({ titulo, texto, confirmarLabel, ocupado, onConfirm, onClose }) => (
  <Modal onClose={onClose}>
    <div
      className="w-full max-w-md rounded-[20px] border border-gray-100 bg-white p-6 shadow-dv-lg dark:border-white/10 dark:bg-navy-800"
      onClick={(e) => e.stopPropagation()}
    >
      <h3 className="text-lg font-bold text-navy-700 dark:text-white">{titulo}</h3>
      <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">{texto}</p>
      <div className="mt-5 flex justify-end gap-2">
        <button
          type="button"
          autoFocus
          onClick={onClose}
          className="rounded-xl border border-gray-200 px-5 py-2.5 text-sm font-semibold text-gray-700 transition-all hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dv-blue-500/40 active:scale-[.98] dark:border-white/15 dark:text-gray-200 dark:hover:bg-white/5"
        >
          Cancelar
        </button>
        <button
          type="button"
          disabled={ocupado}
          onClick={onConfirm}
          className="rounded-xl bg-ink-900 px-5 py-2.5 text-sm font-bold text-white shadow-dv-md transition-all hover:bg-ink-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dv-blue-500/40 active:scale-[.98] disabled:cursor-not-allowed disabled:opacity-50 dark:bg-white dark:text-ink-900 dark:hover:bg-gray-100"
        >
          {ocupado ? "Enviando…" : confirmarLabel}
        </button>
      </div>
    </div>
  </Modal>
);

export default ConfirmarModal;
